import cn from 'classnames'
import React from 'react'

import { testProps } from 'utils/test/qaData'

import type { CourseKitSize } from '../CourseKitTypes'
import * as s from './IconsCourse.module.scss'
import { ICON_MAP } from './generate/iconMap'

type SVGDefaultElement = React.SVGProps<SVGSVGElement> & { title?: string | undefined }

export type CourseKeyIconsType = keyof typeof ICON_MAP

/**
 * Props for the Icon component.
 */
export interface IIconProps extends SVGDefaultElement {
  /**
   * The name of the icon to display.
   */
  name: CourseKeyIconsType
  /**
   * The size of the icon. Can be a KitSize(16/20/24/28) or a number in px.
   */
  size?: CourseKitSize | number
  /**
   * Test data used for automated testing.
   */
  testData?: string
}

const IconCourse = React.forwardRef<SVGSVGElement, IIconProps>(
  ({ name, className, size, testData, ...rest }, ref) => {
    const Svg = ICON_MAP[name]
    const iconClass = cn(s.root, typeof size === 'string' && s[size], className)
    const iconStyle = { ...rest.style, ...(typeof size === 'number' && { fontSize: size }) }

    return (
      <Svg
        {...testProps({ el: 'icon', icon: name, testData })}
        {...rest}
        className={iconClass}
        ref={ref}
        style={iconStyle}
      />
    )
  },
)

IconCourse.displayName = 'IconCourse'

export default IconCourse
